import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateUtilityService {
  public getUserTimezone(): string {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch {
      return 'UTC';
    }
  }

  public formatTimezoneDisplay(dateString: string): string {
    try {
      const date = new Date(dateString);
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const time = `${hours}:${minutes}`;
      const userTimezone = this.getUserTimezone();
      const timezoneAbbr = this._getTimezoneAbbreviation(userTimezone);

      return `${time} ${timezoneAbbr}`;
    } catch {
      return '00:00 UTC';
    }
  }

  public formatDate(dateString: string): string {
    try {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = date.toLocaleDateString('en-US', { month: 'short' });
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    } catch {
      return 'Invalid Date';
    }
  }

  public convertServerTimeToUserTimezone(serverDateString: string): Date {
    try {
      const serverDate = new Date(serverDateString);
      const serverTimezoneOffset = 8;
      const utcDate = new Date(serverDate.getTime() - serverTimezoneOffset * 60 * 60 * 1000);
      const localDate = new Date(utcDate.getTime() + new Date().getTimezoneOffset() * 60 * 1000);

      return localDate;
    } catch {
      return new Date();
    }
  }

  private _getTimezoneAbbreviation(timezoneId: string): string {
    try {
      const date = new Date();
      const options: Intl.DateTimeFormatOptions = { timeZone: timezoneId, timeZoneName: 'short' };
      const formatter = new Intl.DateTimeFormat('en-US', options);
      const parts = formatter.formatToParts(date);

      const timezonePart = parts.find(part => part.type === 'timeZoneName');
      if (timezonePart) {
        return timezonePart.value;
      }

      if (timezoneId.includes('/')) {
        const parts = timezoneId.split('/');

        return parts[parts.length - 1].substring(0, 3).toUpperCase();
      }

      return timezoneId.substring(0, 3).toUpperCase();
    } catch {
      return 'UTC';
    }
  }
}
